import React, { useContext, useState, useEffect,useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import { ViewModelServiceContext, withViewModelService } from 'gw-portals-viewmodel-react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useDependencies } from 'gw-portals-dependency-react';
import { useValidation } from 'gw-portals-validation-react';
import { ModalNextProvider } from '@jutro/components';
import metadata from './WaterCraftComponent.metadata.json5';
import messages from './WaterCraftComponent.messages';
import styles from './WaterCraftComponent.module.scss';


function WaterCraftComponent(props) {
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        coverableVM,
        authHeader,
        updatePackage,
        onValidate,
        type,
        packageIndex
    } = props;

    const {
        registerComponentValidation,
    } = useValidation(type);
    
    const viewModelService = useContext(ViewModelServiceContext);  

    useEffect(() => {
        if(coverableVM.waterCraftDetails.motorDetails.length > 0){
            _.each(coverableVM.waterCraftDetails.motorDetails.value, (motorDetail) => {
                motorDetail.isMotorValidationRequired = true;
            });
        }
    }, []);

    const addAdditionalWaterCraftDetails = useCallback(() => {
        const homeAdditionalWaterCraftDetails = _.get(
            coverableVM,
            'waterCraftDetails.motorDetails'
        );

        homeAdditionalWaterCraftDetails.value = homeAdditionalWaterCraftDetails.value || [];
        const { _xCenter, _dtoName } = homeAdditionalWaterCraftDetails;
        const additionalWaterCraftVM = viewModelService.create({ 'isMotorValidationRequired' : true  }, _xCenter, _dtoName);
        additionalWaterCraftVM.isNewSubmission.value = coverableVM.omiaDetail.isNewSubmission.value;
        homeAdditionalWaterCraftDetails.pushElement(additionalWaterCraftVM);
        const newCoverableVM = viewModelService.clone(coverableVM);
        updatePackage(newCoverableVM.value,packageIndex);
    }, [coverableVM, updatePackage, viewModelService]);

    const onModelChange = (updatedVM) => {
        const newCoverableVM = viewModelService.clone(updatedVM);
        updatePackage(newCoverableVM.value,packageIndex);
    }

    const removeAdditionalWaterCraft = useCallback(
        (evt) => {
            const additionWaterCraftPath = evt.path;
            const additionalWaterCraftListPath = additionWaterCraftPath.replace(
                /\.children\.\d+$/,
                '.value'
            );
            const additionalWaterCraftToRemove = _.get(coverableVM, additionWaterCraftPath);
            const additionalWaterCraftList = _.get(coverableVM, additionalWaterCraftListPath);

            ModalNextProvider.showConfirm({
                title: translator(messages.removeMotorTrailerEquipmentDetails),
                message: translator(messages.defaultMotorTrailerEquipmentDetails),
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.additionalModalYes,
                cancelButtonText: messages.additionalModalNo
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }
                    const newAdditionalWaterCraftList = additionalWaterCraftList.filter(
                        (additionalWaterCraft, index) => {
                            // eslint-disable-next-line
                            const additionalWaterCraftListPathWithoutValue = additionalWaterCraftListPath.replace(
                                '.value',
                                ''
                            );
                            const currentAdditionalWaterCraftPath = `${additionalWaterCraftListPathWithoutValue}.children.${index}`;
                            // eslint-disable-next-line
                            const isCorrectPath = currentAdditionalWaterCraftPath === additionWaterCraftPath;

                            return !(
                                isCorrectPath
                                && _.isEqual(additionalWaterCraft, additionalWaterCraftToRemove.value)
                            );
                        }
                    );

                    if(newAdditionalWaterCraftList.length === 0){
                        coverableVM.waterCraftDetails.motorDetails.isMotorValidationRequired = false;
                    }

                    _.set(coverableVM, additionalWaterCraftListPath, newAdditionalWaterCraftList);
                    const newcoverableVM = viewModelService.clone(coverableVM);
                    updatePackage(newcoverableVM.value,packageIndex);
                    return true;
                }, _.noop
            );
        },
        [coverableVM, updatePackage,translator]
    );
  
    const additionalWaterCraft = _.get(
        coverableVM,
        'waterCraftDetails.motorDetails.value'
    );

    const overrideTitleProps = useCallback(() => {
        if (additionalWaterCraft !== undefined) {
            const overrideProps = additionalWaterCraft.map((value, index) => {
                value.isValidationRequired = true;
                return {
                    [`hoAdditionalWaterCraft${index}`]: {
                        visible: index === 0
                    },
                    [`hoAdditionalWaterCraftCount${index}`]: {
                        visible: index >= 0,
                        content: translator(messages.headingMotorTrailerEquipmentDetails) + parseInt(index + 1)
                    }
                };
            });

            return Object.assign({}, ...overrideProps);
        } else { return null }
    }, [additionalWaterCraft, translator, coverableVM]);

    const overrideBoatProps = useCallback(() => {
        if (additionalWaterCraft !== undefined) {
            const overrideProps = additionalWaterCraft.map((value, index) => {
                return {
                    [`boatdescription${index}`]: {
                        visible: value.motorType == "equipment"
                    }
                };
            });

            return Object.assign({}, ...overrideProps);
        } else { return null }
    }, [additionalWaterCraft, translator, coverableVM]);

  
    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showRequired: true
        },
        hoAddAnotherWaterCraftDetails: {
            visible: additionalWaterCraft !== undefined ? additionalWaterCraft.length > 0 : false
        },
        hoAddAdditionalWaterCraftDetails: {
            visible: additionalWaterCraft !== undefined ? additionalWaterCraft.length > 0 : false
        },
        ...overrideTitleProps(),
        ...overrideBoatProps()
    };

    const resolvers = {
        resolveCallbackMap: {
            onAddAdditionalWaterCraft: addAdditionalWaterCraftDetails,
            onRemoveAdditionalWaterCraft: removeAdditionalWaterCraft
        }
    };

    return (
        
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={coverableVM}
                overrideProps={overrideProps}
                onModelChange={onModelChange}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
            />
      
    );

}

WaterCraftComponent.propTypes = {
    availableValues: PropTypes.array
}
export default WaterCraftComponent
